export function storyRuntime(blocks=[]){
  const seconds=blocks.reduce((sum,b)=>sum+(Number.isFinite(Number(b.end))&&Number.isFinite(Number(b.start))?Math.max(0,Number(b.end)-Number(b.start)):0),0);
  const words=blocks.reduce((sum,b)=>sum+(String(b.text||'').trim().match(/\S+/g)||[]).length,0);
  return {seconds,words};
}
export function validTarget(value){
  if(value===null||value===undefined||value==='')return null;
  const n=Number(value);return Number.isInteger(n)&&n>=30&&n<=3600?n:null;
}
export function targetProgress(seconds,target){
  if(!validTarget(target))return null;
  const fraction=seconds/target;
  return {fraction,over:seconds>target,secondsOver:Math.max(0,Math.round(seconds-target)),fillPercent:Math.max(0,Math.min(100,fraction*100)),targetPercent:seconds>target?target/seconds*100:100};
}
export function clockTime(seconds){
  const n=Math.max(0,Math.round(Number(seconds)||0));return `${Math.floor(n/60)}:${String(n%60).padStart(2,'0')}`;
}

// Keep the visual green band and guidance text tied to the same tolerance.
// A tighter +/-10% window avoids describing a noticeably short edit as on target.
export const TARGET_WINDOW_FRACTION=0.10;

/** Short, non-judgemental pacing advice for the Assembly duration guide.
 * Keep it informational: a concise edit can be better than a padded one.
 */
export function runtimeGuidance(seconds,target){
  const goal=validTarget(target);
  if(goal===null)return {state:'unset',message:'Set a target for pacing guidance.'};
  const current=Math.max(0,Number(seconds)||0);
  if(current===0)return {state:'empty',message:'Add a passage to start building your edit.'};
  const delta=current-goal;
  if(Math.abs(delta)<=goal*TARGET_WINDOW_FRACTION)
    return {state:'near',message:'Looking good — your edit is within the target range.'};
  if(delta<0)
    return {state:'under',message:`${clockTime(-delta)} under target · Room for another strong passage.`};
  return {state:'over',message:`${clockTime(delta)} over target · Consider tightening a few selects.`};
}

/** Display geometry for the Assembly duration gauge. The scale grows only
 * when an edit exceeds its usual range, so the current marker stays visible.
 * A target is a soft +/- 10% window, not an editing limit.
 */
export function runtimeGauge(seconds,target){
  const current=Math.max(0,Number(seconds)||0),goal=validTarget(target);
  const maxSeconds=Math.max(60,Math.ceil(Math.max(
    goal===null?current*1.25:goal*1.6,
    current*1.15
  )/15)*15);
  const pct=value=>Math.max(0,Math.min(100,value/maxSeconds*100));
  return {
    maxSeconds,
    currentPercent:Math.max(1,Math.min(99,pct(current))),
    targetPercent:goal===null?null:pct(goal),
    greenStartPercent:goal===null?null:pct(goal*(1-TARGET_WINDOW_FRACTION)),
    greenEndPercent:goal===null?null:pct(goal*(1+TARGET_WINDOW_FRACTION)),
    // Distinct colour zones mean the marker and text always agree:
    // cobalt/cyan = under, emerald = within 10%, amber/coral = over.
    // Use coincident stops at each threshold so colours do not turn green
    // ahead of the "within target" advice or stay green after it expires.
    gradient:goal===null?null:`linear-gradient(90deg,
      #6975a9 0%, #5688b9 ${pct(goal*.55)}%,
      #33a1b8 ${pct(goal*.78)}%,
      #33a1b8 ${pct(goal*(1-TARGET_WINDOW_FRACTION))}%,
      #20ad79 ${pct(goal*(1-TARGET_WINDOW_FRACTION))}%,
      #109563 ${pct(goal)}%,
      #39b984 ${pct(goal*(1+TARGET_WINDOW_FRACTION))}%,
      #e2ab62 ${pct(goal*(1+TARGET_WINDOW_FRACTION))}%,
      #ce806e ${pct(goal*1.5)}%,
      #b46d87 100%)`
  };
}
